import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing a view for filtering points graphics.
 * @extends JetView
 */
export default class FilterPointsGraphicsView extends JetView {
    /**
     * Configures the layout of the filter points graphics view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        // Left section containing input fields
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for ID
                            name: 'Id',
                            type: 'number',
                            label: _("<span class='icon-id'></span> ID"), // Localized label
                            labelPosition: 'top',
                            placeholder: _('ID'), // Placeholder text
                            invalidMessage: _('ID'), // Invalid message
                        },
                        {
                            view: 'richselect', // Dropdown for State selection
                            name: 'State',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Options for the dropdown
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Encendida') },
                                { id: 'I', value: _('Apagada') },
                            ],
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity element for layout
                    ],
                },
            ],
        };

        // Upper section containing the left input fields
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 150 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including left section
                },
            ],
        };

        // Button section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity element for layout
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'), // Localized button text
                            width: screen == 'small' ? 0 : 100, // Conditional width
                            minWidth: 200,
                            click: () => {
                                // Click event handler
                                this.getRoot().clear(); // Clear form values
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'), // Localized button text
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Conditional width
                            minWidth: 200,
                            click: () => {
                                // Click event handler
                                if (this.getRoot().validate()) {
                                    // Validate form
                                    const filterdata = this.getRoot().getValues(); // Get form values
                                    this.app.callEvent('pointsGraphics:filter', [filterdata]); // Trigger filter event
                                }
                            },
                        },
                    ],
                },
            ],
        };

        // Return the complete configuration for the form
        return {
            view: 'form',
            rows: [upper_section, buttons], // Include upper section and buttons
            elementsConfig: {
                on: {
                    onChange: function (newv, oldv) {
                        // Change event handler
                        this.validate(); // Validate on change
                    },
                },
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 820) {
                // Conditional logic for screen width
                $$('grav').hide(); // Hide gravity element
                $$('grav2').hide(); // Hide gravity element
            }
        });
    }
}

// FILE DOCUMENTED
